module.exports = __webpack_public_path__ + "img/exclamation.a1b40bcb.svg";